<template>
    <div class="property-listing-card-header">
        <property-listing-card-labels
                :property-app-resource="propertyAppResource"
                :hide-on-balloon="true"
        />
        <property-listing-card-carousel
                :property-app-resource="propertyAppResource"
                :hide-on-balloon="false"
                :display-single-image="true"
                :show-controls="showControls"
        />
        <div
                class="compliance d-flex flex-row-reverse w-100"
                style="position: absolute; z-index: 1; margin-top: -2rem; padding-right: 0.5rem;"
        >
            <b-img
                    v-if="emblem"
                    :src="emblem.url"
                    :width="emblem.width"
                    :height="emblem.height"
                    style="background: white"
            />
        </div>
    </div>
</template>

<script>
    import PropertyListingCardLabels from "./PropertyListingCardLabels";
    import AppResource from "@milestoneslabs/milestones-js-engine/src/Data/AppResource";
    import PropertyListingCardCarousel from "./PropertyListingCardCarousel";
    import PropertyAppResource from "@milestoneslabs/milestones-core-js/src/AppResources/PropertyAppResource";

    export default {
        name: "PropertyListingCardHeader",
        components: {
            PropertyListingCardCarousel,
            PropertyListingCardLabels
        },
        data() {
            return {
                emblem: null,
            };
        },
        props: {
            propertyAppResource: {
                type: Object,
                required: true,
                validator(value){
                    return value.constructor.name === (new PropertyAppResource()).constructor.name;
                }
            },
            showControls: {
                type: Boolean,
                default: true,
            }
        },
        methods: {
            getEmblem() {
                if (
                    !this.propertyAppResource.compliance ||
                    !this.propertyAppResource.compliance.summary ||
                    !this.propertyAppResource.compliance.summary.emblem
                ) {
                    this.emblem = null;

                    return;
                }

                this.emblem = {
                    url: this.propertyAppResource.compliance.summary.emblem.asset.url,
                    width: this.propertyAppResource.compliance.summary.emblem.asset.width,
                    height: this.propertyAppResource.compliance.summary.emblem.asset.height,
                };
            }
        },
        mounted() {
            this.getEmblem();
        },
    };
</script>
